// gtag.js is loaded statically in public/index.html (matching reservation-machine):
//   <script async src="https://www.googletagmanager.com/gtag/js?id=G-38K714R9Q2"></script>
//   gtag('config', 'G-38K714R9Q2', { currency, cookie_domain:'.24rent.fi', cookie_flags })
// It loads only on production hostnames, so localhost/staging never send to the live
// property (those use ga4Event's console-log path). gtag is the sole GA4 sender —
// GTM's GA4 tags are paused. This module just sets the user_id once the customer is
// known, so the same person stitches across www <-> m.

const GA4_ID = "G-38K714R9Q2"; // must match the static config in public/index.html

export const setGa4User = (user: { id?: number | string } | undefined | null): void => {
  if (!user || user.id == null) return;
  const w = window as any;
  if (typeof w.gtag === "function") {
    w.gtag("config", GA4_ID, { user_id: String(user.id) });
  }
};
